/**
 * Silent Knowledge Map collection (docs/MECHANICS.md): every finished round credits its
 * facts as "k" (known — answered right) or "l" (learned — shown the answer).
 * Known never downgrades to learned. The map screen that displays this comes later.
 */
import { store } from "./storage";

export type Tier = "k" | "l";
/** fact id → tier + first date it was earned (YYYY-MM-DD) */
export type Knowledge = Record<string, { t: Tier; d: string }>;
/** fact slot (e.g. "c0", "i2") → tier, as produced by a round */
export type Credits = Record<string, Tier>;

const KEY = "facts";

export const getKnowledge = (): Knowledge => store.get<Knowledge>(KEY) ?? {};

export function mergeCredits(k: Knowledge, roundId: string, credits: Credits, date: string): Knowledge {
  const next = { ...k };
  for (const [slot, t] of Object.entries(credits)) {
    const id = `${roundId}:${slot}`;
    const prev = next[id];
    if (!prev) next[id] = { t, d: date };
    else if (prev.t === "l" && t === "k") next[id] = { t: "k", d: prev.d };
  }
  return next;
}

export function credit(roundId: string, credits: Credits, date: string): void {
  store.set(KEY, mergeCredits(getKnowledge(), roundId, credits, date));
}
